import { render, staticRenderFns } from "./FluidLayout.vue?vue&type=template&id=6233bf71&scoped=true"
import script from "./FluidLayout.vue?vue&type=script&lang=js"
export * from "./FluidLayout.vue?vue&type=script&lang=js"
import style0 from "./FluidLayout.vue?vue&type=style&index=0&id=6233bf71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6233bf71",
  null
  
)

export default component.exports